<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import ListResponseActivityAnswersView from '../lists/ListResponseActivityAnswersView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  components: {
    'header-view': HeaderView,
    'main-menu-instructor-view': MainMenuInstructorView,
    'list-response-activity-answers-view': ListResponseActivityAnswersView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <h4 class="item_title">
                  <i class="uil uil-notes" /> Todas las actividades a revisar
                </h4>
                <div class="la5lo1">
                  <list-response-activity-answers-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>